import { render, staticRenderFns } from "./Customer-Filter.vue?vue&type=template&id=8817d14e"
import script from "./Customer-Filter.vue?vue&type=script&lang=js"
export * from "./Customer-Filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports